import { ISelectValue } from 'constants/globalTypes'

export interface IAttendancePolicyWorkflowStepState {
  id?: number
  order: number
  name: string
  resolverType: ISelectValue
  roles: ISelectValue[]
  users: ISelectValue[]
}

export interface IAttendancePolicyState {
  id?: number
  name: string
  description: string
  isActive?: boolean
  workflowSteps: IAttendancePolicyWorkflowStepState[]
}

export const attendancePolicyResolverTypeOptions = [
  { label: 'Role', value: 1 },
  { label: 'User', value: 2 },
]

export const emptyAttendancePolicyState = (): IAttendancePolicyState => ({
  name: '',
  description: '',
  workflowSteps: [
    {
      id: Date.now(),
      name: '',
      order: 1,
      resolverType: { label: 'Role', value: 1 },
      roles: [],
      users: [],
    },
  ],
})
